/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.models {

    export class ApiConfigurationModel {

        private systemLevel: Wars.Domain.Model.SystemLevel;
        processConfiguration: Wars.Domain.Model.ProcessConfiguration;
        apiConfigurations: Wars.Domain.Model.ApiConfiguration[];
        apiConfiguration: Wars.Domain.Model.ApiConfiguration;
        objectQueries: Array<Wars.Domain.Model.ObjectQuery>;
        showEdit: boolean;
        editingNew: boolean;
        editingExisting: boolean;
        public exampleUrl: string;
        public keys: Wars.Domain.Model.ApiKey[];

        constructor(
            private scope: angular.IScope,
            private growlService: angular.growl.IGrowlService,
            private processConfigurationId: string,
            private processConfigurationService: services.ProcessConfigurationService,
            private systemLevelService: services.SystemLevelService,
            private apiConfigurationService: services.ApiConfigurationService,
            private queryConfigurationService: services.QueryConfigurationService,
            private objectQueryService: services.ObjectQueryService,
            private deleteService: services.DeleteService,
            private apiKeyService: services.ApiKeyService,
            private externalApiService: services.ExternalApiService,
            private baseUrl: string)
        {
            apiKeyService.getKeys().then(keys => {
                this.keys = keys;
            });

            this.baseUrl += "api/ExternalApi/";

            if (this.processConfigurationId) {
                this.apiConfigurationService.getAllApiConfigurationsByProcessId(this.processConfigurationId)
                    .then((apiConfigurations) => {
                        this.apiConfigurations = apiConfigurations;
                    });
                objectQueryService.getAllObjectQueriesForProcessConfiguration(this.processConfigurationId)
                    .then(objectQueries => {
                        this.objectQueries = Enumerable.from(objectQueries).where(i => i.isExecutable).toArray();
                    });
                this.processConfigurationService.getProcessConfigEagerLoadProcessType(this.processConfigurationId).then(
                    (processConfig) => {
                        this.processConfiguration = processConfig;
                    });
            } else {
                this.systemLevelService.getSystemLevelApiConfigurations()
                    .then((systemLevel) => {
                        this.systemLevel = systemLevel;
                        this.apiConfigurations = systemLevel.myApiConfigurations;
                    });
                objectQueryService.getAllObjectQueriesForSystemLevel()
                    .then(objectQueries => {
                        this.objectQueries = objectQueries;
                    });
            }
        }


        addApiConfiguration() {
            var newApiConfiguration = this.apiConfigurationService.createApiConfiguration();
            if (this.processConfigurationId) {
                newApiConfiguration.processConfiguration_id = this.processConfigurationId;
            } else {
                newApiConfiguration.systemLevel_id = this.systemLevel.id;
            }
            newApiConfiguration.uniqueIdentifier = services.UtilityService.generateGuidComb();
            this.apiConfigurationService.saveAllChanges(() => {
                this.apiConfiguration = newApiConfiguration;
                this.apiConfigurations.push(newApiConfiguration);
                this.showEdit = true;
                this.editingNew = true;
            });
        }

        configureApiConfiguration(apiConfiguration: Wars.Domain.Model.ApiConfiguration) {
            this.apiConfiguration = apiConfiguration;
            this.showEdit = true;
            this.editingExisting = true;
            this.setExampleUrl();
        }

        deleteApiConfiguration(apiConfiguration: Wars.Domain.Model.ApiConfiguration) {
            this.deleteService.deleteWithModalConfirmationIfNecessary(
                "ApiConfiguration",
                apiConfiguration.id,
                "Successfully delete API Configuration",
                () => {
                    this.apiConfigurations.remove(apiConfiguration);
                    this.showEdit = false;
                },
                "Could not delete API Configuration");
        }

        selectApiQuery() {
            if (this.apiConfiguration.parameters.length > 0) {
                this.apiConfiguration.parameters.forEach(parameter => {
                    parameter.entityAspect.setDeleted();
                });
            }
            if (this.apiConfiguration.myObjectQuery &&
                this.apiConfiguration.myObjectQuery.myInputObjectSchema &&
                this.apiConfiguration.myObjectQuery.myInputObjectSchema.properties) {
                this.apiConfiguration.myObjectQuery.myInputObjectSchema.properties
                    .forEach(property => {
                        var queryParameter = this.queryConfigurationService.createNewQueryParameter();
                        queryParameter.name = property.name;
                        queryParameter.mySchemaProperty = property;
                        queryParameter.schemaProperty_id = property.id;
                        this.apiConfiguration.parameters.push(queryParameter);
                    });
            }
            this.saveChanges();
        }

        saveChanges() {
            this.setExampleUrl();
            this.apiConfigurationService.saveAllChanges();
        }

        private setExampleUrl(): void {
            if (this.apiConfiguration.name === null || this.apiConfiguration.name === undefined) return;

            var apiName = this.apiConfiguration.name.replace(/\s+/g, '-').toLowerCase();
            var processConfigName = this.processConfigurationId
                ? this.processConfiguration.myProcessType.name.replace(/\s+/g, '-').toLowerCase()
                : '';

            if (this.apiConfiguration.apiType === Wars.Domain.Model.Codes.Enums.ApiType.QueryGet) {
                if (this.processConfigurationId) {
                    var url = this.baseUrl + processConfigName + "/Query/" + apiName;
                    this.exampleUrl = this.addQueryStringParams(url, this.apiConfiguration.parameters);
                } else {
                    var url = this.baseUrl + "Query/" + apiName;
                    this.exampleUrl = this.addQueryStringParams(url, this.apiConfiguration.parameters);
                }
            } else if (this.apiConfiguration.apiType === Wars.Domain.Model.Codes.Enums.ApiType.PerProcessGet) {
                var paramerterPart = this.apiConfiguration.inputType ===
                    Wars.Domain.Model.Codes.Enums.ProcessApiInputType.ProcessName
                    ? "/[processName]"
                    : "/[processId]";

                if (this.processConfigurationId) {
                    this.exampleUrl = this.baseUrl +
                        "GetAllProcessData/" +
                        processConfigName +
                        "/" +
                        apiName +
                        paramerterPart;
                } else {
                    this.exampleUrl = this.baseUrl + "GetAllProcessData/" + apiName + paramerterPart;
                }
            }
        }

        private addQueryStringParams(url: string, parameters: Wars.Domain.Model.OperationParameter[]): string {
            if (parameters && parameters.length > 0) {
                url += "?";
                for (let i = 0; i < parameters.length; i++) {
                    url += parameters[i].name.replace(/\s+/g, '-').toLowerCase() + "=[paramValue]&"
                }
                url = url.substring(0, url.length - 1);
            }
            return url;
        }

        private close() {
            this.showEdit = false;
        }
    }
}